<mat-icon [popover]="popTemplate" popoverTitle="Description" [outsideClick]="true"
    containerClass="process-stat-popover-container" [placement]="placement" class="hint-icon" [ngClass]="hintIconClass"
    container="body">info</mat-icon>
<ng-template #popTemplate>
    <div style="position: unset;">
        <div [innerHtml]="tooltipValue"></div>
    </div>
</ng-template>